import { useState } from 'react';
import { Trans, useTranslation } from "react-i18next";

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography'

import LanguageButton from '../components/LanguageButton'
import MenuButton from '../components/MenuButton'
import Title from '../components/Title'

import logo from '../images/Header/Logo_PhytoWatch.png'

function Header() {

    const { t } = useTranslation();

  return (

    <Container className="header pb-5">

      <Grid container
        className="p-4"
        justifyContent="space-between"
      >
        <Grid>
          <LanguageButton />
        </Grid>

        <Grid>
          <MenuButton />
        </Grid>

      </Grid>

      <Grid container className="" justifyContent="center">
        <img src={logo} className="headerlogo" />
      </Grid>



      <Grid container className="px-10" justifyContent="center">


        <Title variant="header" color="orange"
          text="header_title" />


      </Grid>


    </Container>
  );
}

export default Header;
